import { render, staticRenderFns } from "./MarkAuctionAsPaidAction.vue?vue&type=template&id=897d2398&scoped=true&"
import script from "./MarkAuctionAsPaidAction.vue?vue&type=script&lang=ts&"
export * from "./MarkAuctionAsPaidAction.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "897d2398",
  null
  
)

export default component.exports